"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PointerTransition = exports.MouseTransition = exports.HTML5DragTransition = exports.TouchTransition = void 0;

var _createTransition = require("./createTransition");

var TouchTransition = (0, _createTransition.createTransition)('touchstart', function (rawEvent) {
  var event = rawEvent;
  return event.touches !== null && event.touches !== undefined;
});
exports.TouchTransition = TouchTransition;
var HTML5DragTransition = (0, _createTransition.createTransition)('dragstart', function (event) {
  return event.type.indexOf('drag') !== -1 || event.type.indexOf('drop') !== -1;
});
exports.HTML5DragTransition = HTML5DragTransition;
var MouseTransition = (0, _createTransition.createTransition)('mousedown', function (event) {
  return event.type.indexOf('touch') === -1 && event.type.indexOf('mouse') !== -1;
});
exports.MouseTransition = MouseTransition;
var PointerTransition = (0, _createTransition.createTransition)('pointerdown', function (rawEvent) {
  var event = rawEvent;
  return event.pointerType == 'mouse';
});
exports.PointerTransition = PointerTransition;